import { FileOutlined } from '@ant-design/icons';
import { type InoltroAllegatoComunicazione } from '@framework/api-client/api/inquiries-compile/schemas/inoltroAllegatoComunicazione.ts';
import { useField } from '@framework/form/field/useField.tsx';
import { TextAreaInput } from '@framework/form/inputs/TextAreaInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { DividerTitleElement } from '@framework/ui/components/text/DividerTitleElement.tsx';
import { Checkbox, Space, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledWrapper = styled.div`
  padding-left: 20px;
  border-left: 4px solid ${({ theme }) => theme.colorPrimary};
`;

interface ICommunicationForwardFieldsProps {}

export const CommunicationForwardFields = (
  props: ICommunicationForwardFieldsProps,
) => {
  const { t } = useTranslation();

  // lista degli allegati della comunicazione
  const forwardedAttachmentField =
    useField<InoltroAllegatoComunicazione[]>('inoltro.allegati');
  const forwardedAttachments = useWatch({
    name: 'inoltro.allegati',
  }) as InoltroAllegatoComunicazione[];
  const [forwardedAttachmentsList, setForwardedAttachmentsList] =
    useState<InoltroAllegatoComunicazione[]>();

  useEffect(() => {
    if (forwardedAttachmentsList) return;
    const value = forwardedAttachmentField.getValue();
    setForwardedAttachmentsList(value);
  }, [forwardedAttachmentField, forwardedAttachmentsList]);

  return (
    <>
      <StyledWrapper>
        <DividerTitleElement
          title={t('communication-forward.title', 'Comunicazione Inoltrata')}
        />
        <FormItem
          name="inoltro.messaggio"
          label={t(
            'communications.forward.input.message.label',
            'Comunicazione Inoltrata',
          )}
        >
          <TextAreaInput
            autoSize={{ minRows: 6 }}
            name="inoltro.messaggio"
            placeholder={t(
              'communications.forward.input.message.placeholder',
              'Comunicazione inoltrata',
            )}
            // rows={6}
          />
        </FormItem>
        {!!forwardedAttachmentsList?.length && (
          <>
            <Typography.Title level={5}>
              {t(
                'communications.forward.input.attachments.label',
                'Allegati della comunicazione inoltrata',
              )}
            </Typography.Title>
            {forwardedAttachmentsList.map((attachment, index) => (
              <div key={attachment.idAllegato}>
                <Checkbox
                  checked={forwardedAttachments?.some(
                    a => a.idAllegato === attachment.idAllegato,
                  )}
                  onChange={e => {
                    if (e.target.checked) {
                      forwardedAttachmentField.setValue([
                        ...forwardedAttachments,
                        attachment,
                      ]);
                    } else {
                      forwardedAttachmentField.setValue(
                        forwardedAttachments.filter(
                          a => a.idAllegato !== attachment.idAllegato,
                        ),
                      );
                    }
                  }}
                >
                  <Space size={4}>
                    <span style={{ fontSize: '1.3em' }}>
                      <FileOutlined />
                    </span>
                    {attachment.allegato.nomeFile}
                  </Space>
                </Checkbox>
              </div>
            ))}
            <Typography.Text type="secondary">
              {t(
                'communications.forward.input.attachments.help',
                'Seleziona gli allegati da inoltrare',
              )}
            </Typography.Text>
          </>
        )}
      </StyledWrapper>
    </>
  );
};
